"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var fn_1 = require("ayvri-std/lib/fn");
var colors_1 = require("ayvri-ui/lib/styles/colors");
var Color = require("color");
var moment = require("moment");
var preconditions_ts_1 = require("preconditions-ts");
var index_1 = require("./index");
exports.cleanSceneInputs = function (scene) {
    scene.title = typeof scene.title === 'string' ? index_1.escapeHtml(scene.title) : scene.title;
    scene.description = index_1.escapeHtml(scene.description || '');
    return scene;
};
exports.getActivitiesFromScenes = function (scenes) {
    return scenes.map(function (s) { return preconditions_ts_1.required(s.activityType); }).filter(function (a, i, self) { return a && self.indexOf(a) === i; });
};
exports.addActivityColors = function (scene) {
    var usedColors = [];
    return __assign({}, scene, { activities: scene.activities.map(function (activity, index) {
            var color = colors_1.getNextAvatarColor(usedColors);
            var _a = Color(color).array(), r = _a[0], g = _a[1], b = _a[2];
            usedColors.push(color);
            return __assign({}, activity, { color: "rgb(" + r + ", " + g + ", " + b + ")" });
        }) });
};
exports.hideUI = function (elements) {
    if (elements === void 0) { elements = ['terrainProfile']; }
    return function (scene) {
        return __assign({}, scene, { hideElements: (scene.hideElements || []).concat(elements) });
    };
};
exports.disableAutoplay = function (scene) {
    return __assign({}, scene, { autoplay: false });
};
exports.processScene = function (input) {
    var processors = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        processors[_i - 1] = arguments[_i];
    }
    return processors.reduce(function (scene, proc) {
        return proc(scene);
    }, exports.toPlayerScene(input));
};
exports.toPlayerScene = function (scene) {
    var activities = (scene.activities || []).filter(exports.isActivity);
    return __assign({}, scene, { title: scene.title || '', segments: scene.segments || [], activities: activities });
};
exports.isActivity = function (activity) {
    return !!activity && typeof activity !== 'string';
};
exports.deriveStartPoint = function (scene) {
    return preconditions_ts_1.required(exports.getFirstOrLastActivity(scene, 'startPoint').startPoint, 'Could not derive start point for scene');
};
exports.deriveEndPoint = function (scene) {
    return preconditions_ts_1.required(exports.getFirstOrLastActivity(scene, 'endPoint').endPoint, 'Could not derive end point for scene');
};
// this function is used to get the first activity in the scene (i.e. the one with the earliest startPoint.time),
// or, the last activity (i.e. the one with the latest endPoint.time).
exports.getFirstOrLastActivity = function (scene, key) {
    if (scene.activities.length === 0) {
        throw new Error("attempting to derive " + key + " for a scene that has no activities");
    }
    var points = scene.activities
        .map(function (activity) { return fn_1.pair(activity, moment(preconditions_ts_1.required(activity[key]).time)); })
        .sort(function (a, b) { return (a.right() > b.right() ? 1 : -1); });
    return points[key === 'startPoint' ? 0 : points.length - 1].left();
};
